{
  "version": 1,
  "presets": [
    {
      "id": "balanced",
      "label": "Balanced",
      "hint": "Soil type 70% · moisture 20% · yield/NDVI peak 10%",
      "layers": [
        {
          "role": "ssurgo_mapunit",
          "weight": 70
        },
        {
          "role": "twi",
          "weight": 20
        },
        {
          "role": "yield_or_ndvi",
          "weight": 10
        }
      ]
    },
    {
      "id": "soil",
      "label": "Pure Soil Type",
      "hint": "SSURGO map unit only",
      "layers": [
        {
          "role": "ssurgo_mapunit",
          "weight": 100
        }
      ]
    },
    {
      "id": "moisture",
      "label": "Topographic Moisture",
      "hint": "TWI only",
      "layers": [
        {
          "role": "twi",
          "weight": 100
        }
      ]
    }
  ]
}
